import { useEffect, useRef, type InputHTMLAttributes } from 'react'
import { cn } from '@/lib/cn'

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  /** Jadval sarlavhasida: qatorlarning bir qismi tanlangan. */
  indeterminate?: boolean
}

export function Checkbox({ className, indeterminate, ...props }: CheckboxProps) {
  const ref = useRef<HTMLInputElement>(null)

  useEffect(() => {
    // `indeterminate` faqat DOM xossasi — atributi yo'q, React uni o'rnata olmaydi.
    if (ref.current) ref.current.indeterminate = Boolean(indeterminate)
  }, [indeterminate])

  return (
    <input
      ref={ref}
      type="checkbox"
      className={cn(
        'h-3.5 w-3.5 shrink-0 cursor-pointer appearance-none rounded-sm',
        'border border-border-strong bg-surface-1',
        'checked:bg-accent checked:border-accent',
        'indeterminate:bg-accent indeterminate:border-accent',
        // Belgini CSS bilan chizamiz — ikonka importi qatorlar sonicha takrorlanmasin.
        'checked:after:content-["✓"] checked:after:block checked:after:text-white',
        'checked:after:text-[10px] checked:after:leading-[12px] checked:after:text-center',
        'indeterminate:after:content-["–"] indeterminate:after:block indeterminate:after:text-white',
        'indeterminate:after:text-[10px] indeterminate:after:leading-[12px] indeterminate:after:text-center',
        'disabled:opacity-40 disabled:cursor-not-allowed',
        className,
      )}
      {...props}
    />
  )
}
